export default "__VITE_ASSET__Cllj8svW__"